import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Card,
  CardMedia,
  useMediaQuery
} from '@material-ui/core';
import aboutMusicMediaImage from '../../../../assets/images/about.png'

import './index.scss';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: 'Helvetica Neue',
  },
  sectionTwo: {
    backgroundColor: 'black',
    // paddingLeft: 20,
    // paddingRight: 20,
    fontSize: '1.2rem',
    color: '#FFF',
    margin: '5px'

  },
  sectionTwoMobile: {
    backgroundColor: 'black',
    fontSize: '.9rem',
    color: '#FFF',
    margin: '5px'

  },
  innerGridContainer: {
    width: "100%",
    margin: "0px",
    // padding: "30px"
  },
  innerGridHeading: {
    width: "100%",
    textAlign: "center",
    fontSize: "3rem",
  },
  sectionParagraph: {
    margin: "10px 0px",

  },
  media: {
    height: 350,
    maxWidth: 700,
    float: 'right',
    width: '100%'
  },
}));

export default function SectionTwo() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionTwo : classes.sectionTwoMobile}>
        <Grid className={classes.innerGridContainer} container spacing={1}>
          <Grid item xs={12} sm={4} >
            <Card className={classes.media + ' effect-oscar'} >
              <CardMedia
                component="img"
                className={classes.media}
                image="https://www.musicminduat.dk/media/artist_covers/Home_Images/section2IMG/musik.JPG"
                title="about music"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={4} >
            <Card className={classes.media + ' effect-oscar'} >
              <CardMedia
                component="img"
                className={classes.media}
                image="https://www.musicminduat.dk/media/artist_covers/Home_Images/section2IMG/signage.JPG"
                title="about signage"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={4} >
            <Card className={classes.media + ' effect-oscar'} >
              <CardMedia
                component="img"
                className={classes.media}
                image="https://www.musicminduat.dk/media/artist_covers/Home_Images/section2IMG/oplevelsesdesign.JPG"
                title="about oplevelsesdesign"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={4} >
            <Card className={classes.media + ' effect-oscar'} >
              <CardMedia
                component="img"
                className={classes.media}
                image="https://www.musicminduat.dk/media/artist_covers/Home_Images/section2IMG/streaming.JPG"
                title="about streaming"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={4} >
            <Card className={classes.media + ' effect-oscar'} >
              <CardMedia
                component="img"
                className={classes.media}
                image="https://www.musicminduat.dk/media/artist_covers/Home_Images/section2IMG/software.JPG"
                title="about software"
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card className={classes.media + ' effect-oscar'} >
              <CardMedia
                component="img"
                className={classes.media}
                image="https://www.musicminduat.dk/media/artist_covers/Home_Images/section2IMG/musicmind.JPG"
                title="about musicmind"
              />
            </Card>
          </Grid>
        </Grid>
      </section>
    </div>
  )
}